import React from 'react';
import PoeticButton from '../ui/PoeticButton';
import SolarEclipseBrand from '../ui/SolarEclipseBrand';

interface HeroProps {
  onStartAudio: () => void;
}

const Hero: React.FC<HeroProps> = ({ onStartAudio }) => {
  return (
    <section
      className="relative h-screen h-[100svh] h-[100dvh] flex items-center justify-center overflow-hidden bg-black"
    >
      {/* Subtle ambient glow behind brand */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-500/5 rounded-full blur-[120px] pointer-events-none will-change-transform translate-z-0" />


      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center px-8 text-center -mt-16 md:-mt-24 -translate-y-[50px]">

        {/* Main Branding - Maximum Prominence */}
        <h1 className="mb-2 md:mb-4 relative group translate-y-[30px]">
          <span className="sr-only">Solunn - Free Ambient Soundscape Generator for Meditation and Focus</span>
          <SolarEclipseBrand className="text-6xl sm:text-8xl md:text-[9rem] lg:text-[11rem]" />
        </h1>

        {/* Secondary Tagline - Subtle and Ethereal */}
        <div className="flex flex-col items-center gap-2 md:gap-4 mb-6 md:mb-8">
          <div className="flex items-center justify-center gap-2 md:gap-4 text-xs sm:text-sm md:text-lg tracking-[0.4em] md:tracking-[0.6em] uppercase font-light text-white/80">
            <span>Breathe</span>
            <span className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
            <span>Touch</span>
            <span className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
            <span>Create</span>
          </div>

          <p className="text-cyan-100/90 text-sm md:text-base font-medium tracking-wide max-w-sm italic drop-shadow-[0_0_8px_rgba(34,211,238,0.2)]">
            A serene space for creative meditation and ambient soundscapes.
          </p>
        </div>

        {/* CTA Button - Zen voice */}
        <PoeticButton onClick={onStartAudio}>
          Enter the Flow
        </PoeticButton>
      </div>


      {/* Scroll Indicator - now precisely at the bottom of dVH */}
      <div
        className="absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce motion-reduce:animate-none opacity-70 hover:opacity-100 focus-visible:opacity-100 transition-opacity cursor-pointer touch-manipulation min-h-[40px] min-w-[40px] justify-center outline-none focus-visible:ring-2 focus-visible:ring-cyan-400/50 rounded-full"
        onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
        role="button"
        aria-label="Scroll down to explore"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      >
        <span className="text-[10px] tracking-widest uppercase text-white font-semibold">Explore</span>
        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>

      {/* Animation keyframes */}



    </section>
  );
};

export default Hero;
